import { API_URL } from "@/mainconfig";

const state = {
    error: null,
    errorMessage: null,
    loading: false,
};

const getters = {
    isLoading: (state) => state.loading,
    getVoucherError: (state) => state.errorMessage,
};

const actions = {
    async applyVoucher({ commit }, payload) {
        commit("setLoading", true);

        console.log("Payload di Vuex Action:", payload); // Debugging payload di Vuex Action

        try {
            const response = await API_URL.post("/voucher/apply", payload);
            commit("setError", null);

            console.log("response", response);
            return response.data; // Kembalikan hasil response jika diperlukan
        } catch (error) {
            commit(
                "setError",
                error.response?.data?.msg || "Failed to apply voucher."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    // CH-W54 — voucher milik user (owned) + disarankan (suggested)
    async getMyVouchers({ commit }, payload) {
        try {
            const bookingCode = payload?.bookingCode;
            const url = bookingCode
                ? `/voucher/mine?bookingCode=${encodeURIComponent(bookingCode)}`
                : "/voucher/mine";
            const response = await API_URL.get(url, { requiresAuth: true });
            return response.data?.data ?? { owned: [], suggested: [] };
        } catch (error) {
            commit("setError", error.response?.data?.msg || "Failed to load vouchers.");
            return { owned: [], suggested: [] };
        }
    },

    async removeVoucher({ commit }, payload) {
        commit("setLoading", true);

        console.log("Payload di Vuex Action:", payload); // Debugging payload di Vuex Action

        try {
            const response = await API_URL.post("/voucher/remove", payload);
            commit("setError", null);

            console.log("response", response);
            return response.data; // Kembalikan hasil response jika diperlukan
        } catch (error) {
            commit(
                "setError",
                error.response?.data?.msg || "Failed to apply voucher."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },

    async processCheckout({ commit }, payload) {
        commit("setLoading", true);

        console.log("Payload di Vuex Action:", payload); // Debugging payload di Vuex Action

        try {
            const response = await API_URL.post("/booking/checkout", payload);
            commit("setPaymentStatus", "success");
            commit("setError", null);
            if (response.status === 200 && response.data?.code === 0) {
                console.log(
                    "Checkout berhasil, menghapus roomCart dari localStorage."
                );
                localStorage.removeItem("roomCart"); // Hapus roomCart dari localStorage
            }

            console.log("response", response);
            return response.data; // Kembalikan hasil response jika diperlukan
        } catch (error) {
            commit("setPaymentStatus", "failed");
            commit(
                "setError",
                error.response?.data?.message || "Failed to process checkout."
            );
            throw error;
        } finally {
            commit("setLoading", false);
        }
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setPaymentStatus(state, status) {
        state.paymentStatus = status;
    },
    setError(state, error) {
        state.error = error;
        state.errorMessage = error || "An error occurred.";
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
